import { Button, makeStyles, tokens, Tooltip } from '@fluentui/react-components';
import { TextBulletListSquareEdit20Regular } from '@fluentui/react-icons';
import { FC, MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';
import { IUnitTestProps } from '../../data-types/IUnitTestProps';

const useEnterAmountsIconStyles = makeStyles({
    icon: {
        color: tokens.colorBrandForeground2,
    },
});

export interface IEnterAmountsDialogButtonProps extends IUnitTestProps {
    className?: string;
    onButtonClick: MouseEventHandler<HTMLButtonElement>;
}

export const EnterAmountsDialogButton: FC<IEnterAmountsDialogButtonProps> = (props: IEnterAmountsDialogButtonProps) => {
    const { onButtonClick, className } = props;
    const { t } = useTranslation();
    const iconStyles = useEnterAmountsIconStyles();
    return (
        <Tooltip relationship='description' appearance='inverted' withArrow positioning='below' content={t('enterAmounts').toString()}>
            <Button
                icon={<TextBulletListSquareEdit20Regular className={iconStyles.icon} />}
                onClick={onButtonClick}
                className={className}
                tabIndex={0}
                aria-label={t('enterAmountsButtonLabel').toString()}
            />
        </Tooltip>
    );
};
